import React, { useEffect, useState } from 'react'
import { Typography, LinearProgress, makeStyles, Theme, createStyles, Paper, TextField, MenuItem, useMediaQuery, useTheme } from '@material-ui/core'
import Constants, { OptionType, breakpoint } from '../../types/constants';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import { Formik, FormikProps, Form, Field } from 'formik'
import { useGlobal, useDispatch } from 'reactn'
import { useHistory } from 'react-router-dom'
import { Agency } from '../../models/agency';
import LockIcon from '@material-ui/icons/Lock';
import { UamNumberField, UamSelectField, UamSwitchField, UamTextField, UamDateField } from '../../formik/UamTextField';
import { PromptDialogType } from '../../dialog/PromptDialog'
import { AgencyServiceValidation } from '../../core/agency/agencyFunctions';
import { updateAgency } from '../../services/agencyService';
import { useLogger } from '../../logger';
import FormikDebugDisplay from '../../formik/FormikDebugDisplay';
import ErrorSummary from '../../formik/ErrorSummary';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { Company } from '../../models/company';
import { getLevels } from '../../types/auth';

const contentMaxWidth = Constants.PageEditAgencyContentMaxWidth;
const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        overflow: 'auto',
        marginTop: theme.spacing(2),
    },
    error: {
        color: theme.palette.secondary.main,
    },
    fieldContainer: {
        width: contentMaxWidth,
        padding: 10,
        marginBottom: 20,
    },
    passwContainer: {
        padding: 10,
        marginBottom: 0,
        marginTop: 10,
    },
    disflex: {
        display: 'flex',
    },
    id: {

    }
}))

const formTextFieldMargin = 'dense'
export type SaveDataType = {
    values: any[]
}
type AgencyFieldsPropsType = {
    onLockedChange?: (isLocked: boolean) => void,
    onModifiedChange?: (isModified: boolean) => void,
    setSubmitCallback?: (callback: () => Promise<any>) => void,
    setRefreshCallback?: (callback: () => void) => void,
    onSubmit?: () => void,
}

export default function AgencyFields(props: AgencyFieldsPropsType) {
    const theme = useTheme();
    const [currentEditAgencyStatus, setCurrentEditAgencyStatus] = useGlobal<IGlobalState, 'currentEditAgencyStatus'>('currentEditAgencyStatus');
    const [currentEditAgency, setCurrentEditAgency] = useGlobal<IGlobalState, 'currentEditAgency'>('currentEditAgency');
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const [ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const classes = useStyles();
    const [companies] = useGlobal<IGlobalState, 'companies'>('companies');
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));

    const [promptDialogProps, setPromptDialogProps] = useState<PromptDialogType>({ open: false })
    // const { isAdmin } = useAuthBrief();
    const adLevels = getLevels(auth.authData);
    const [agencyService] = useState(() => new AgencyServiceValidation(adLevels))
    const closeDialog = () => setPromptDialogProps({ open: false })
    const dispatch = useDispatch();
    const history = useHistory();
    const logger = useLogger({key: 'agencyFields'});
    // const notifyAgency = useNotifyAgency()
    const agencyFormSchema = agencyService.agencyFormSchemaBase();
    const [companyList, setCompanyList]= useState<OptionType[]>([]);
    let width = mobile ? 'auto' : contentMaxWidth;
    
    const loadCompaniesForAgency = async () => {
        // getCompanies(ip, auth.authData!, auth.user!, new CompanySearchModel()).then(res => {
        let myCompanies: OptionType[]=[];
        companies.forEach((comp: Company) => {
            // console.log('Ciclo le my companies ora sono: ' + myCompanies.length);    
            let item: OptionType = {label: comp.BusinessName, value: comp.Id};
            myCompanies.push(item);
        });
        setCompanyList(myCompanies);
    }

    useEffect(() => {
        console.log('sono in use effect')
        loadCompaniesForAgency();
        console.log('Finito la funz in use effect')
    }, [companies, currentEditAgency]);
    
    return (
        <div className={classes.root}>
            <Formik
                initialValues={{...currentEditAgency!.agency as Agency }}
                validationSchema={agencyFormSchema}
                // validateOnMount={true}
                validateOnChange={true}
                onSubmit={(values, { setSubmitting }) => {
                    console.log(`*** +++ Formik.onSubmit ${currentEditAgencyStatus}`);
                    const updAgency = agencyFormSchema.cast(values);
                    // A questo punto scegliamo se fare un'update o un add in base al valore di oid
                    if (values.Disabled)
                        updAgency.State = 'D';
                    else
                        updAgency.State = 'A';
                    if (updAgency!.Id > 0) {
                        /* TODO
                        */
                        updateAgency(ip, auth.authData!, auth.user!, updAgency).then(updatedAgency => {
                            // console.log('Agency updated', updatedAgency)
                            // e qui dobbiamo sostituire l'utente in editing con quello modificato
                            if (updatedAgency) {
                                //TODO
                                dispatch.agencySaved(updatedAgency);
                                logger.info(`Studio ${updatedAgency.Name} salvato!`);
                            } else {
                                logger.error('Problemi nel salvataggio della agency');
                            }
                        }).catch(error => {
                            console.error('Error in saving Agency');
                            logger.error(error, 'error');
                        }).finally(() => {
                            setSubmitting(false);
                            props.onSubmit && props.onSubmit();
                        })
                    } else {
                        /* TODO Add agency
                        */
                        updAgency.Id = 0;
                        updateAgency(ip, auth.authData!, auth.user!, updAgency).then(response => {
                            console.log('Agency add', response)
                            if (response) {
                                if (response.Id > 0) {
                                    // e qui dobbiamo sostituire l'utente in editing con quello modificato
                                    //aggiornare lo stato
                                    console.log('Sono in add agency con response: ' + JSON.stringify(response));
                                    dispatch.newAgencySaved(response.Id, response);
                                    values.Id = response.Id;
                                    values.InsertDate = response.InsertDate;
                                    logger.info(`Studio ${response.Name} aggiunto correttamente`);
                                } else {
                                    const message = `Errore nel salvataggio: `;
                                    logger.error(message, 'error');
                                }
                            }
                        }).finally(() => {
                            setSubmitting(false);
                            props.onSubmit && props.onSubmit();
                        })
                    }
                }}
            >
                {(formprops: FormikProps<Agency>) => {
                    const { isSubmitting, handleSubmit, values, dirty, submitForm, resetForm, isValid, errors,setFieldValue } = formprops
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    // useEffect(() => {
                    //     //TODO
                    //     if (dirty) {
                    //         if (currentEditAgencyStatus === 'Pristine') { setCurrentEditAgencyStatus('Modified') }
                    //     } else {
                    //         if (currentEditAgencyStatus === 'Modified') { setCurrentEditAgencyStatus('Pristine') }
                    //     }
                    // }, [dirty])
                    if (props.setSubmitCallback) {
                        props.setSubmitCallback(submitForm);
                    } 
                    if (props.setRefreshCallback) {
                        props.setRefreshCallback(resetForm);
                    } 
                    
                    //TODO per bloccare la navigazione se ho sporcato la form, step successivo
                    // const handleNavigationAttempt = (navigation: any, location: any, action: string) => {
                    //     console.log('handleNavigationAttempt', navigation, location, action)
                    //     setPromptDialogProps({
                    //         open: true,
                    //         cancel: () => { closeDialog(); navigation.cancel(); },
                    //         resume: () => {
                    //             closeDialog();
                    //             resetForm();
                    //             //TODO
                    //             setCurrentEditAgencyStatus('Pristine');
                    //             navigation.resume();
                    //         },
                    //     })
                    //     return null;
                    // }

                    return (
                        <Form onSubmit={handleSubmit} translate>
                            {/* <ReactRouterPause handler={handleNavigationAttempt} when={dirty} /> */}
                            {/* <ConfirmNavigation {...promptDialogProps} /> */}
                            <Paper className={classes.fieldContainer} style={{width: width}}>
                                <div className={classes.disflex}>
                                    <TextField label='Id' margin={formTextFieldMargin} value={values.Id} className={classes.id} fullWidth={true}/>
                                    &nbsp;
                                    <UamTextField label='Utenti disponibili' name='PrincipalCounter' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Nome' name='Name' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='P.Iva' name='VatNumber' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Codice' name='Code' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='Provincia' name='ProvinceCode' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Città' name='CityCode' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='Indirizzo' name='Address' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Cap' name='Cap' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamSelectField label='Company' options={companyList} name='CompanyId' fullWidth helperText='' margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <Field as={KeyboardDatePicker} label='Disabled' name='Disabled' 
                                        clearable={true} 
                                        autoOk 
                                        format='DD/MM/YYYY' 
                                        fullWidth margin='dense' 
                                        // value={values.Disabled} 
                                        // onChange={handleDisabledChanged} 
                                        onChange={value => setFieldValue("Disabled", value)}
                                    />
                                    &nbsp;
                                    <Field as={TextField} label='State' name='State' fullWidth margin='dense' inputProps={{readOnly: true}}/>
                                </div>
                                {values.Disabled ?
                                <div className={classes.disflex}>
                                    <LockIcon titleAccess="Studio disabilitato" color="primary"/>
                                </div>
                                : null}
                                {isSubmitting && <LinearProgress color='primary' />}
                            </Paper>
                            {!isValid && <ErrorSummary title='Errori da correggere' errors={errors} schema={agencyFormSchema} />}
                            {/* <FormikDebugDisplay<Agency> hide={false} {...formprops} /> */}
                        </Form>
                    )}
                }
            </Formik>
        </div>
    )
}


